"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAzureRegion = isAzureRegion;
var _types = require("../types");
function isAzureRegion(value) {
  return _types.azureRegionSchemaRaw.safeParse(String(value).toUpperCase()).success;
}
//# sourceMappingURL=isAzureRegion.js.map